import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { allArticles } from '@/mocks/categories';

export default function ArticleLinkSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label uppercase tracking-wider mb-3">
            Полезные статьи
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            Руководства и сравнения YOYBUY Spreadsheet
          </h2>
          <p className="mt-2 text-foreground-600 text-sm max-w-2xl">
            Изучите наши подробные статьи о заказах из Китая, сравнении систем и лучших практиках использования YOYBUY Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-colors cursor-pointer flex flex-col"
            >
              <div className="aspect-[1.6/1] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-foreground-800 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.summary}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-foreground-600 group-hover:text-accent-600 transition-colors">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                  Читать
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}